import { initSentry } from "./sentry";

const settings = window.ICE?.settings?.sentry;
if (settings) {
  initSentry(settings);
}
